import React, {
  useRef,
  useEffect,
} from 'react';
import PropTypes from 'prop-types';

import {
  polygonStyle,
} from '../../../constants';

import {
  getPolygonBounds,
} from '../../../helpers/gmaps';

const ExpandLocalityRadiusTool = ({
  initialized,
  map,
  libraries,
  drawingData,
}) => {
  const polygonRef = useRef(null);
  const changePolygonsIndexRef = useRef(null);
  const renderDelayRef = useRef(0);
  
  const drawPolygon = (path, index, subindex) => {
    const {
      core: { LatLng },
      maps: { Polygon },
    } = libraries;

    const latLngPath = path.map((p) => p.map((node) => new LatLng({ lat: node[1], lng: node[0] })));

    if (subindex || subindex === 0) {
      if (!polygonRef.current[index]) {
        polygonRef.current[index] = [];
      }
      
      polygonRef.current[index][subindex] = new Polygon({ ...polygonStyle.complete, strokeOpacity: 1, strokeWeight: 2 });
      polygonRef.current[index][subindex].setPaths(latLngPath);
      polygonRef.current[index][subindex].setMap(map);
    } else {
      polygonRef.current[index] = new Polygon({ ...polygonStyle.complete, strokeOpacity: 1, strokeWeight: 2 });
      polygonRef.current[index].setPaths(latLngPath);
      polygonRef.current[index].setMap(map);
    }
  };

  const createPolygons = ({ paths }) => {
    const { core: { LatLngBounds } } = libraries;

    paths.forEach((data, locIndex) => {
      if (data.type === 'MultiPolygon') {
        data.coordinates.forEach((subpath, pathIndex) => {
          drawPolygon(subpath, locIndex, pathIndex);
        });
      } else {
        drawPolygon(data.coordinates, locIndex);
      }
    });

    setTimeout(() => {
      const polygonBounds = getPolygonBounds(polygonRef.current, LatLngBounds);
      map.fitBounds(polygonBounds);
    }, renderDelayRef.current);
  };

  useEffect(() => {        
    if (initialized) {
      if (changePolygonsIndexRef.current !== drawingData?.changePolygonsIndex) {
        if (polygonRef.current) {
          polygonRef.current.map((poly) => {
            if (Array.isArray(poly)) {
              poly.map((p) => {
                p.setMap(null);
                return null;
              });
            } else {
              poly.setMap(null);
            }
            return null;
          });
          polygonRef.current = [];
        } else {
          polygonRef.current = [];
        }      
        if (changePolygonsIndexRef.current !== null && renderDelayRef.current === 450) {
          renderDelayRef.current = 0;
        }
        changePolygonsIndexRef.current = drawingData?.changePolygonsIndex;
        createPolygons({
          paths: drawingData?.localityPolygons,
        });
      }
    }
  }, [initialized, drawingData]);

  return null;
};

export default ExpandLocalityRadiusTool;

ExpandLocalityRadiusTool.propTypes = {
  initialized: PropTypes.bool,
  map: PropTypes.instanceOf(Object),
  libraries: PropTypes.instanceOf(Object),
  drawingData: PropTypes.instanceOf(Object),
};

ExpandLocalityRadiusTool.defaultProps = {
  initialized: false,
  map: null,
  libraries: null,
  drawingData: null,
};
